<div class="parametros_container">
    <h2>Parámetros</h2>
    <input
        type="text"
        class="form-control"
        placeholder="Buscar..."
        [(ngModel)]="searchTerm"
        (input)="filterParams()" />

    <table class="table">
        <thead>
            <tr>
                <th>ID</th>
                <th>Tipo</th>
                <th>Nombre</th>
                <th>Valor</th>
                <th *appPermiso="'editar_parametros'">Acciones</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let param of filteredParam">
                <td>{{ param.id || '-' }}</td>
                <td>{{ param.tipo }}</td>
                <td>{{ param.nombre }}</td>

                <td>
                    <span *ngIf="!param.editing">{{ param.valor }}</span>

                    <div *ngIf="param.editing">
                        <input
                            type="text"
                            [(ngModel)]="param.valor"
                            (ngModelChange)="validarValor(param)"
                            [ngClass]="{
                                'is-invalid': param.invalido,
                                'form-control': true,
                            }" />

                        <div
                            *ngIf="param.invalido"
                            class="invalid-feedback d-block">
                            <ng-container [ngSwitch]="param.tipo">
                                <span *ngSwitchCase="'fecha'">
                                    Formato de fecha inválido. Use dd-mm-aaaa.
                                </span>
                                <span *ngSwitchCase="'numero'">
                                    Ingrese un número válido.
                                </span>
                                <span *ngSwitchCase="'texto'">
                                    Solo se permiten letras y espacios.
                                </span>
                                <span *ngSwitchDefault>Valor inválido.</span>
                            </ng-container>
                        </div>
                    </div>
                </td>

                <td *appPermiso="'editar_parametros'">
                    <button
                        *ngIf="!param.editing"
                        (click)="enableEditing(param)"
                        class="btn btn-info btn_parametro">
                        Editar
                    </button>
                    <button
                        *ngIf="param.editing"
                        (click)="saveParam(param)"
                        [disabled]="param.invalido"
                        class="btn btn-info btn_parametro">
                        Guardar
                    </button>

                    <button
                        *ngIf="param.editing"
                        (click)="cancelEditing(param)"
                        class="btn btn-warning btn_parametro">
                        Cancelar
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
